import vonixRing from '@/assets/sounds/vonix_ring1.wav'

const DTMFAudio = function () {
  this.const_DTMF_row_frequency = [1209, 1336, 1477, 1633]
  this.const_DTMF_col_frequency = [697, 770, 852, 941]
  this.const_DTMF_key = ['1', '2', '3', 'A', '4', '5', '6', 'B', '7', '8', '9', 'C', '*', '0', '#', 'D']
  this.const_audio_sample_rate = 44100
  this.const_sine_samples = 44100
  this.volume = 0.1

  this.audioCtx = null
  this.volCtl = null
  this.var_DTMF_buffer = {}
  this.var_DTMF_mix_list = {}
  this.var_Precise_Tone_Plan_buffer = {}
  this.var_source = null

  this.var_dial_isdialing = false
  this.var_dial_interval = null
  this.var_dial_time_rate = 40
  this.var_dial_message = ''
  this.var_dial_message_index = 0
  this.var_timeout_function = null

  // this.primaryDeviceId = 'default'
  this.additionalDeviceId = 'default'

  this.destination = null

  this.additionalAudioElement = null
  this.additionalGain = null
  this.additionalDestination = null

  this.chatRingTimeout = null

  this.audioBuffer = null
  this.currentSource = null

  this.init = async function () {
    try {
      window.AudioContext = window.AudioContext || window.webkitAudioContext

      this.audioCtx = new AudioContext()
      this.volCtl = this.audioCtx.createGain()
      this.volCtl.gain.value = this.volume
      this.volCtl.connect(this.audioCtx.destination)

      this.additionalAudioElement = new Audio()
      this.additionalGain = this.audioCtx.createGain()
      this.additionalDestination = this.audioCtx.createMediaStreamDestination()
      this.additionalGain.gain.value = 0.4
      this.additionalGain.connect(this.additionalDestination)
      this.additionalAudioElement.srcObject = this.additionalDestination.stream
      await this.trySetSinkId(this.additionalAudioElement, this.additionalDeviceId)
      await this.trySetSinkId(this.additionalAudioElement, this.additionalDeviceId)

      this.PopulateDTMFBuffer()
      this.PopulatePreciseTonePlan()

      await this.loadRingtone()
    } catch (e) {
      alert('Web Audio API is not supported in this browser, We recommend You Download a Copy of Mozilla Firefox or Google Chrome!')
    }
  }

  this.trySetSinkId = async function (audioElement, deviceId) {
    try {
      await audioElement.setSinkId(deviceId)
      await new Promise(resolve => setTimeout(resolve, 100))
      await this.additionalAudioElement.play()
    } catch (err) {
      console.warn('Additional device setSinkId error:', err)
    }
  }

  this.loadRingtone = async function () {
    const response = await fetch(vonixRing)
    const arrayBuffer = await response.arrayBuffer()
    this.audioBuffer = await this.audioCtx.decodeAudioData(arrayBuffer)
  }

  this.setOutputDevices = async function (additionalDeviceId) {
    if (additionalDeviceId) {
      this.additionalDeviceId = additionalDeviceId
      try {
        await this.trySetSinkId(this.additionalAudioElement, additionalDeviceId)
      } catch (err) {
        console.error('Failed to update secondary device:', err)
      }
    }
  }

  this.MakeDTMFSineBuffer = function (frequencyA, frequencyB) {
    const buffer = this.audioCtx.createBuffer(1, this.const_sine_samples, this.const_audio_sample_rate)
    const channel = buffer.getChannelData(0)
    for (let i = 0; i < this.const_sine_samples; ++i) {
      channel[i] = Math.sin((frequencyA * 2 * Math.PI * i) / this.const_audio_sample_rate) + Math.sin((frequencyB * 2 * Math.PI * i) / this.const_audio_sample_rate)
    }
    return buffer
  }

  this.PopulatePreciseTonePlan = function () {
    let auxSamples = this.const_audio_sample_rate * 6
    let buffer = this.audioCtx.createBuffer(1, auxSamples, this.const_audio_sample_rate)
    let channel = buffer.getChannelData(0)
    let frequencyA = 350
    let frequencyB = 440

    let fadeArray = []
    let delayAsSample = Math.floor(this.const_audio_sample_rate * 0.7) // 2
    let fadeIfValue = Math.floor(delayAsSample * 0.10) // 2

    const fillBuffer = function () {
      for (let i = 0; i < delayAsSample; i++) {
        if (i <= fadeIfValue) {
          fadeArray[i] = (1.0 / fadeIfValue) * i
        } else if (i >= delayAsSample - fadeIfValue - 1) {
          fadeArray[i] = (1.0 / fadeIfValue) * (delayAsSample - (i + 1))
        } else {
          fadeArray[i] = 1
        }
      }

      for (let i = 0; i < auxSamples; ++i) {
        if (i < delayAsSample) {
          channel[i] = fadeArray[i] * Math.sin((frequencyA * 2 * Math.PI * i) / this.const_audio_sample_rate) + fadeArray[i] * Math.sin((frequencyB * 2 * Math.PI * i) / this.const_audio_sample_rate)
        } else {
          channel[i] = 0
        }
      }
    }

    fillBuffer.call(this)
    this.var_Precise_Tone_Plan_buffer.dial = buffer

    // Ringback Tone 2x on 4x off
    auxSamples = this.const_audio_sample_rate * 6
    buffer = this.audioCtx.createBuffer(1, auxSamples, this.const_audio_sample_rate)
    channel = buffer.getChannelData(0)
    frequencyA = 440
    frequencyB = 480

    fadeArray = []
    delayAsSample = this.const_audio_sample_rate * 2 // 1
    fadeIfValue = Math.floor(delayAsSample * 0.10) // 1

    fillBuffer.call(this)
    this.var_Precise_Tone_Plan_buffer.ringback = buffer

    // busy tone
    auxSamples = this.const_audio_sample_rate
    buffer = this.audioCtx.createBuffer(1, auxSamples, this.const_audio_sample_rate)
    channel = buffer.getChannelData(0)
    frequencyA = 480
    frequencyB = 620

    fadeArray = []
    delayAsSample = Math.floor(this.const_audio_sample_rate * 0.5) // 2
    fadeIfValue = Math.floor(delayAsSample * 0.10) // 2

    fillBuffer.call(this)
    this.var_Precise_Tone_Plan_buffer.busy = buffer

    // reorder tone
    auxSamples = Math.floor(this.const_audio_sample_rate * 0.5)
    buffer = this.audioCtx.createBuffer(1, auxSamples, this.const_audio_sample_rate)
    channel = buffer.getChannelData(0)
    frequencyA = 480
    frequencyB = 620

    fadeArray = []
    delayAsSample = Math.floor(auxSamples * 0.5) // 3
    fadeIfValue = Math.floor(delayAsSample * 0.10) // 3

    fillBuffer.call(this)
    this.var_Precise_Tone_Plan_buffer.reorder = buffer

    // off-hook tone
    auxSamples = Math.floor(this.const_audio_sample_rate * 0.2)
    buffer = this.audioCtx.createBuffer(1, auxSamples, this.const_audio_sample_rate)
    channel = buffer.getChannelData(0)
    frequencyA = 1400
    frequencyB = 2060
    const frequencyC = 2450
    const frequencyD = 2600
    fadeArray = []
    delayAsSample = Math.floor(auxSamples * 0.5) // 4
    fadeIfValue = Math.floor(delayAsSample * 0.10) // 4

    for (let i = 0; i < delayAsSample; i++) {
      if (i <= fadeIfValue) {
        fadeArray[i] = (1.0 / fadeIfValue) * i
      } else if (i >= delayAsSample - fadeIfValue - 1) {
        fadeArray[i] = (1.0 / fadeIfValue) * (delayAsSample - (i + 1))
      } else {
        fadeArray[i] = 1
      }
    }

    for (let i = 0; i < auxSamples; ++i) {
      if (i < delayAsSample) {
        channel[i] = fadeArray[i] * Math.sin((frequencyA * 2 * Math.PI * i) / this.const_audio_sample_rate) + fadeArray[i] * Math.sin((frequencyB * 2 * Math.PI * i) / this.const_audio_sample_rate) + fadeArray[i] * Math.sin((frequencyC * 2 * Math.PI * i) / this.const_audio_sample_rate) + fadeArray[i] * Math.sin((frequencyD * 2 * Math.PI * i) / this.const_audio_sample_rate)
      } else {
        channel[i] = 0
      }
    }

    this.var_Precise_Tone_Plan_buffer.howler = buffer

    this.var_Precise_Tone_Plan_buffer.slackPing = this.createDingBuffer()
  }

  this.createDingBuffer = function () {
    const sampleRate = this.const_audio_sample_rate
    const duration = 0.5 // half a second
    const samples = Math.floor(sampleRate * duration)
    const buffer = this.audioCtx.createBuffer(1, samples, sampleRate)
    const channel = buffer.getChannelData(0)

    const freq = 500 // the main tone
    const harmonic = 3000 // optional higher overtone

    for (let i = 0; i < samples; i++) {
      const t = i / sampleRate
      const envelope = Math.exp(-3 * t) // exponential fade

      // Optional: mix harmonic for richness
      channel[i] = envelope * (
        Math.sin(2 * Math.PI * freq * t) * 0.8 +
      Math.sin(2 * Math.PI * harmonic * t) * 0.2
      )
    }

    return buffer
  }

  this.createNoteBuffer = function (frequency, duration = 0.2) {
    const samples = Math.floor(this.const_audio_sample_rate * duration)
    const buffer = this.audioCtx.createBuffer(1, samples, this.const_audio_sample_rate)
    const channel = buffer.getChannelData(0)

    const fadeSamples = Math.floor(samples * 0.1)
    for (let i = 0; i < samples; i++) {
      let fade = 1
      if (i < fadeSamples) {
        fade = i / fadeSamples // fade-in
      } else if (i > samples - fadeSamples) {
        fade = (samples - i) / fadeSamples // fade-out
      }
      channel[i] = fade * Math.sin((2 * Math.PI * frequency * i) / this.const_audio_sample_rate)
    }

    return buffer
  }

  this.PopulateDTMFBuffer = function () {
    let bufferIndex = 0
    for (let lc = 0; lc < this.const_DTMF_col_frequency.length; lc++) {
      for (let lr = 0; lr < this.const_DTMF_row_frequency.length; lr++) {
        const hashKey = this.const_DTMF_key[bufferIndex]
        const frequencyA = this.const_DTMF_row_frequency[lr]
        const frequencyB = this.const_DTMF_col_frequency[lc]

        this.var_DTMF_buffer[hashKey] = this.MakeDTMFSineBuffer(frequencyA, frequencyB)
        this.var_DTMF_mix_list[hashKey] = [frequencyA, frequencyB]
        bufferIndex = bufferIndex + 1
      }
    }
  }

  function createBufferSource () {
    this.var_source = this.audioCtx.createBufferSource()
    if (!this.var_source.start) {
      this.var_source.start = this.var_source.noteOn
    }
    if (!this.var_source.stop) {
      this.var_source.stop = this.var_source.noteOff
    }
  }

  this.generateDTMF = function (key) {
    this.stop()
    createBufferSource.call(this)

    this.var_source.loop = true
    this.var_source.connect(this.volCtl)

    this.var_source.buffer = this.var_DTMF_buffer[key]
    this.var_source.start(0)
  }

  this.stopDTMF = function () {
    if (this.chatRingTimeout) clearTimeout(this.chatRingTimeout)
    this.chatRingTimeout = null

    if (this.var_source != null) {
      this.var_source.stop(0)
    }
  }

  this.stop = function () {
    if (this.chatRingTimeout) clearTimeout(this.chatRingTimeout)
    this.chatRingTimeout = null

    this.stop_dial_interval()
    if (this.var_source != null) {
      this.var_source.stop(0)
      this.var_source = null
    }

    this.stopRinging()
  }

  this.stop_dial_interval = function () {
    if (this.var_dial_isdialing) {
      window.clearInterval(this.var_dial_interval)
      this.var_dial_interval = null
      if (this.var_source != null) {
        this.var_source.stop(0)
        this.var_source = null
      }
      this.var_dial_isdialing = false
    }
    this.var_dial_message = ''
    this.var_dial_message_index = 0
  }

  this.play = function (key) {
    this.generateDTMF(key)
    setTimeout(() => this.stopDTMF(), 100)
  }

  this.playCustom = function (key) {
    if (!(key in this.var_Precise_Tone_Plan_buffer)) {
      return alert(`Precise Tone has no : ${key}`)
    }

    this.stop()
    createBufferSource.call(this)

    this.var_source.loop = true
    // this.var_source.connect(this.audioCtx.destination);
    this.var_source.connect(this.volCtl)
    this.var_source.buffer = this.var_Precise_Tone_Plan_buffer[key]
    this.var_source.start(0)
  }

  this.stopRinging = function () {
    if (this.currentSource) {
      try {
        this.currentSource.stop()
      } catch (e) {
        console.warn('Error while stopping current source:', e)
      }
      this.currentSource.disconnect()
      this.currentSource = null
    }
  }

  this.playVonixRingtone = async function () {
    this.stop()

    if (!this.audioBuffer) {
      console.warn('Audio buffer not loaded yet')
      return
    }

    const source = this.audioCtx.createBufferSource()
    source.buffer = this.audioBuffer
    source.loop = true
    this.currentSource = source

    source.connect(this.additionalGain)

    if (this.audioCtx.state === 'suspended') {
      await this.audioCtx.resume()
    }

    source.start()
    try {
      await this.additionalAudioElement.play()
    } catch (err) {
      console.warn('Error playing audio element:', err)
    }
  }

  this.playHangup = function () {
    this.stop()

    setTimeout(() => {
      this.playCustom('busy')
      setTimeout(() => this.stop(), 800)
    }, 350)
  }

  this.playNewChat = function () {
    this.stop()

    setTimeout(() => {
      this.playVonixRingtone()
      setTimeout(() => this.stop(), 800)
    }, 350)
  }

  this.playChatRingback = function () {
    this.stop()

    setTimeout(() => {
      this.playVonixRingtone()
      this.chatRingTimeout = setTimeout(() => this.stop(), 30000)
    }, 350)
  }

  return this
}

export default DTMFAudio.call({})
